module.exports = __webpack_public_path__ + "fonts/shipnity.7115c0e9.eot";